import request from '@/utils/request'

// 获取验证码
export function requestConfirmCode (params) {
  return request({
    url: `/wuneng-user-web/web/user/sendcaptchacode`,
    method: 'post',
    params
  })
}
// 注册请求
export function requestRegist (params) {
  return request({
    url: `/wuneng-affairs-web/affairs/user/save`,
    method: 'post',
    params
  })
}
// 登录请求
export function requestLogin (params) {
  return request({
    url: `/wuneng-user-web/web/user/login`,
    method: 'post',
    params
  })
}
// 退出请求
export function requestLogout (params) {
  return request({
    url: `/wuneng-user-web/web/user/logout`,
    method: 'post',
    params
  })
}
// 重置密码请求
export function requestResetpwd (params) {
  return request({
    url: `/wuneng-user-web/web/user/resetpwd`,
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js